import { bootToolPage } from '../lib/boot-tool'
import { openStage } from '../lib/stage'
import { stageMarkup } from '../lib/stage-html'
import { t } from '../i18n/dictionaries'

const COLORS = [
  '#000000',
  '#ffffff',
  '#ff0000',
  '#00ff00',
  '#0000ff',
  '#00ffff',
  '#ff00ff',
  '#ffff00',
  '#808080',
]

type Marker = { x: number; y: number; color: string }

const locale = bootToolPage('solid-color')
document.body.insertAdjacentHTML(
  'beforeend',
  stageMarkup({ controls: ['exit', 'prev', 'next', 'mark', 'hide'] }),
)
document.querySelectorAll<HTMLElement>('[data-stage-root] [data-i18n]').forEach((node) => {
  const key = node.dataset.i18n
  if (key) node.textContent = t(locale, key)
})

let index = 0
let markMode = false
let running = false
const markers: Marker[] = []

const list = document.querySelector('[data-marker-list]')
const stage = document.querySelector<HTMLElement>('[data-stage-root]')
const canvas = document.querySelector<HTMLElement>('[data-stage-canvas]')

function paint(): void {
  if (!canvas) return
  document.querySelectorAll<HTMLButtonElement>('[data-swatch]').forEach((button) => {
    const active = Number(button.dataset.swatch) === index
    button.classList.toggle('is-active', active)
    button.setAttribute('aria-pressed', String(active))
  })
  canvas.style.background = COLORS[index]
  canvas.replaceChildren()
  markers
    .filter((m) => m.color === COLORS[index])
    .forEach((m) => {
      const dot = document.createElement('div')
      dot.style.cssText = `position:absolute;left:${m.x}px;top:${m.y}px;width:18px;height:18px;margin:-9px 0 0 -9px;border:2px solid #fff;border-radius:50%;box-shadow:0 0 0 1px #000;pointer-events:none`
      canvas.appendChild(dot)
    })
  const label = stage?.querySelector('[data-stage-label]')
  if (label) {
    const markTag = markMode ? ` · ${t(locale, 'mark').toUpperCase()}` : ''
    label.textContent = `${COLORS[index]} · ${t(locale, 'marks_label')} ${markers.length}${markTag}`
  }
  if (list) {
    list.innerHTML = markers
      .map(
        (m, i) =>
          `<li><span>${i + 1}</span><strong class="mono">${Math.round(m.x)}, ${Math.round(m.y)}</strong> · ${m.color}</li>`,
      )
      .join('')
  }
}

function beginTest(): void {
  if (!stage || !canvas || running) return
  running = true
  const close = openStage(stage, {
    onExit: () => {
      close()
      running = false
    },
    onPrev: () => {
      index = (index - 1 + COLORS.length) % COLORS.length
      paint()
    },
    onNext: () => {
      index = (index + 1) % COLORS.length
      paint()
    },
    onMark: () => {
      markMode = !markMode
      paint()
    },
  })
  paint()
  canvas.onclick = (event) => {
    if (markMode) {
      markers.push({ x: event.clientX, y: event.clientY, color: COLORS[index] })
      paint()
      return
    }
    index = (index + 1) % COLORS.length
    paint()
  }
}

document.querySelector('[data-action="start"]')?.addEventListener('click', () => {
  beginTest()
})

document.querySelectorAll<HTMLButtonElement>('[data-swatch]').forEach((btn) => {
  btn.style.background = COLORS[Number(btn.dataset.swatch)]
  btn.addEventListener('click', () => {
    index = Number(btn.dataset.swatch)
    paint()
  })
})
paint()

document.querySelector('[data-action="clear-marks"]')?.addEventListener('click', () => {
  markers.length = 0
  paint()
})

if (new URLSearchParams(location.search).get('start') === '1') {
  beginTest()
}
